import * as React from 'react';

import { isHeadless } from '@/components/IntersectionObserverWrapper/utils';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';

import CategoryRenderer, {
  CategoryRendererWithSlidesPropTypes,
} from './Category';
import styles from './Category.module.scss';
import GhostCategory from './GhostCategory';

const CategoryHolder: React.FC<CategoryRendererWithSlidesPropTypes> = props => {
  const { ref, intersected } = useIntersectionObserver(isHeadless);

  // During back action RP category regularly fails to render correctly with intersection observer
  return props.component_type === 'recently_played' ? (
    <div ref={ref} className={styles.singleWrapper}>
      <CategoryRenderer {...props} />
    </div>
  ) : (
    <div ref={ref} className={styles.singleWrapper}>
      {intersected ? (
        <CategoryRenderer {...props} />
      ) : (
        <GhostCategory category={props.category} />
      )}
    </div>
  );
};

export default CategoryHolder;
